
const stateCode = {
  0: '成功',
  1007: '未知错误',
  999: '服务器未知错误',
  9999: '失败',
  10000: '认证失败',
  10020: '资源不存在',
  10030: '参数错误',
  10040: '令牌失效',
  10050: '令牌过期',
  10060: '字段重复',
  10070: '不可操作',
  10100: 'refreshToken异常',
}

export default stateCode
